import { tabsAnatomy } from "@chakra-ui/react-v3/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react-v3";
import { transition } from "theme/tokens/transition";

export const tabsRecipe = defineSlotRecipe({
  slots: tabsAnatomy.keys(),

  base: {
    root: {
      position: "relative",
      _horizontal: {
        display: "block",
      },
      _vertical: {
        display: "flex",
      },
    },

    list: {
      display: "inline-flex",
      position: "relative",
      isolation: "isolate",
      justifyContent: "flex-start",
      _horizontal: {
        flexDirection: "row",
      },
      _vertical: {
        flexDirection: "column",
      },
    },

    trigger: {
      outline: "0",
      display: "flex",
      alignItems: "center",
      position: "relative",
      gap: "2",
      py: "2",
      fontWeight: "medium",
      _focusVisible: {
        zIndex: 1,
      },
    },

    content: {
      focusVisibleRing: "inside",
      _horizontal: {
        width: "100%",
      },
      _vertical: {
        height: "100%",
      },
    },
  },

  variants: {
    fitted: {
      true: {
        list: {
          display: "flex",
        },
        trigger: {
          flex: 1,
          textAlign: "center",
          justifyContent: "center",
        },
      },
    },

    variant: {
      line: {
        list: {
          display: "flex",
          gap: "6",
          borderColor: "border.divider",
          _horizontal: {
            borderBottomWidth: "1px",
          },
          _vertical: {
            borderEndWidth: "1px",
          },

          // Keep trailing controls, including the service actions menu, above
          // page content such as overview charts.
          zIndex: "1",
        },

        trigger: {
          border: "none",
          px: "0",

          color: "fg.emphasized",
          textStyle: "body.14",
          lineHeight: "tabs",
          whiteSpace: "nowrap",

          transitionProperty: "color",
          transitionDuration: transition.durationMs.extraFast,
          transitionTimingFunction: transition.easing.easeOut,

          // The selected trigger owns the underline, avoiding a shared
          // indicator that slides through the gap between tabs or drifts when
          // a trigger changes width.
          _after: {
            content: "''",
            position: "absolute",
            bottom: "-1px",
            left: "0",
            right: "0",
            h: "1px",
            bg: "highlight.solid",
            opacity: 0,
            transform: "scaleX(0)",
            transformOrigin: "center",
            transitionProperty: "opacity, transform",
            transitionDuration: transition.durationMs.normal,
            transitionTimingFunction: transition.easing.easeOut,
          },

          outlineColor: "transparent",

          _focusVisible: {
            outline: "none",
            outlineColor: "transparent",
            boxShadow: "none",
          },

          _hover: {
            color: "fg.default",
          },

          _active: {
            bg: "none",
          },

          _selected: {
            color: "fg.default",
            _after: {
              opacity: 1,
              transform: "scaleX(1)",
            },
          },

          _disabled: {
            cursor: "default",
            color: "fg.subtle",
            opacity: 1,
            _hover: {
              color: "fg.subtle",
            },
          },
        },
      },
    },
  },

  defaultVariants: {
    variant: "line",
  },
});
